import type { EntitiesState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/entitiesSearchResults';
import type { Reducer } from 'redux';

// combineReducers({}) infers CombinedState<{}> which doesn't satisfy Record<string, never>
const entitiesSearchResults: Reducer<EntitiesState> = (state = {}) => state;

export default entitiesSearchResults;
